import script from "./storeProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./storeProducts.vue?vue&type=script&setup=true&lang=js"

import "./storeProducts.vue?vue&type=style&index=0&id=8d3462b8&lang=scss"

const __exports__ = script;

export default __exports__